import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';

interface AdminGuardProps {
  children: React.ReactNode;
}

export function AdminGuard({ children }: AdminGuardProps) {
  const { isAuthenticated, canManageStoreSettings } = useAuthStore();

  if (!isAuthenticated || !canManageStoreSettings) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
